import { LegalRepository } from '@lib/api/repository/legal/legal.repository';
import { LegalUseCase } from '@lib/interfaces/usecase/legal.use-case';

export default class LegalService implements LegalUseCase {
  constructor(private readonly repository: LegalRepository) {}
  current(signal?: AbortSignal) {
    return this.repository.current(signal);
  }

  status(signal?: AbortSignal) {
    return this.repository.status(signal);
  }

  document(id: string, signal?: AbortSignal) {
    return this.repository.document(id, signal);
  }

  accept(revisionId: string) {
    return this.repository.accept(revisionId);
  }
}
